module.exports = __webpack_public_path__ + "static/media/duiwai.a54bb5bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageUrlSec/duiwai.svg
// module id = 577
// module chunks = 0